<template>
    <div class="mobile-general-form" :class="preview && 'mobile-general-form-preview'">
        <div
            class="fixed-notice-bar"
            v-io
            v-if="showNoticeBar"
            @exposed="exposedNoticeBar"
        >
            <van-notice-bar
                v-if="showNoticeBar"
                :key="openTime"
                left-icon="info"
                background="#FFEEF2"
                color="#FE3666"
                :text="noticeBarText"
                @click="onClickNotice"
            ></van-notice-bar>
        </div>

        <slot name="before-main"></slot>

        <component
            v-if="globalModelInitiated && constComponentMap[mixedConfig.component]"
            :is="constComponentMap[mixedConfig.component]"
            ref="formRef"
            :originConfig="mixedConfig"
            :parentOutputPath="''"
        ></component>

        <slot name="after-main"></slot>

        <!-- TIPS：历史===在浏览器中点击返回，关闭弹窗而不是返回上一个页面。 -->
        <picker-panel v-model="panelShow" :title="popupTitle" @input="onClickCloseIcon">
            <rich-text v-if="rejectNoticeBar" :remark="remark" @emit-click="onClickBtn"></rich-text>
            <iframe
                v-else-if="formNoticeBar && panelShow"
                :src="noticeLink"
                style="width: 100%; height: 70vh; border: none;"
                ref="noticeIframe"
            ></iframe>
        </picker-panel>
    </div>
</template>
<script>
/**
 * # 移动端通用表单
 * 文档待补充，可以视为 @ks/admin-general-form 的移动端版本
 */
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { COMPONENT_MAP, SIMPLE_COMPONENT } from './components/register';
import MobileGeneralFormArray from './components/mobile-general-form-array';
import MobileGeneralFormContainer from './components/mobile-general-form-container';
import MobileGeneralFormListContainer from './components/mobile-general-form-list-container';
import PickerPanel from './components/component-base/common/picker-panel';
import RichText from './components/component-base/common/rich-text';
import GlobalModel from './components/global-model';
import uuid from 'uuid/v1';
import { filterLodashKey, exportMappedData } from './utils';
import Vue from 'vue';
import { NoticeBar } from 'vant';
import formEventBus, { FORM_EVENTS_TYPE } from './utils/event-bus';
import IntersectionObserve from './utils/directives/intersection-observe';
import { RESULT_FALLBACK_VALUE } from './const';
import { injectAllStyleVar } from './utils/dynamic-cdn';
import { getUrlParam } from './utils/url';

Vue.use(NoticeBar);
export default {
    name: 'mobile-general-form',
    components: {
        ...SIMPLE_COMPONENT,
        MobileGeneralFormArray,
        MobileGeneralFormContainer,
        MobileGeneralFormListContainer,
        vanNoticeBar: NoticeBar,
        PickerPanel,
        RichText,
    },
    directives: {
        io: IntersectionObserve,
    },
    props: {
        // 这个参数可以作为API发请求的附带参数
        initParams: {
            type: Object,
            default: () => {},
        },
        // 版本号，暂时无用
        version: {
            type: String,
            default: '1',
        },
        // 表单根组件的配置信息
        config: {
            type: Object,
            default: () => ({}),
        },
        // 表单初始数据
        formData: {
            type: Object,
            default: () => ({}),
        },
        // 全局表单数据
        globalFormData: {
            type: Object,
            default: () => ({}),
        },
        // 是否是b端编辑态
        isEdit: {
            type: Boolean,
            default: false,
        },
        // 全局属性，对应配置的extraConfig字段
        formAttributes: {
            type: Object,
            default: () => ({
                ksFilterLodashKey: true,
            }),
        },
        // 覆盖上传默认行为的方法
        handleUploadAction: {
            type: Function,
            default: null,
        },
        // 覆盖请求默认行为的方法
        handleApiAction: {
            type: Function,
            default: null,
        },
        // 获得上传文件预览图方法
        uploadPreviewMethod: {
            type: Function,
            default: null,
        },
        // 国际化函数 输入code, 输出需要显示的文案
        i18nMethod: {
            type: Function,
            default: null,
        },
        // 处理埋点的函数 需要解析通用表单封装的埋点信息，详见readme
        loggerMethod: {
            type: Function,
            default: null,
        },
        // 是否开启预览
        preview: {
            type: Boolean,
            default: false,
        },
        // 是否是表单类型公告预览
        noticeFormPreview: {
            type: Boolean,
            default: false,
        },
        // 是否隐藏提交样式
        hideSubmitStyle: {
            type: Boolean,
            default: false,
        },
        // 公告内容
        remark: {
            type: String,
            default: '',
        },
        // 公告数据
        formNotice: {
            type: Object,
            default: () => ({}),
        },
        // 错误数据
        errorData: {
            type: Array,
            default: () => [],
        },
        // 信息收集四期灰度
        fieldReview: {
            type: Number,
            default: 0,
            require: false,
        },
        // 是否自动弹起公告
        noticeAutoOpen: {
            type: Boolean,
            default: false,
        },
        openTime: {
            type: Number,
            default: 0,
        },
        // 业务方传入当前 native 页面标题，用于 picker-panel 关闭时恢复安卓 WebView 因 history.go(-1) 引起的标题变化
        nativeTitle: {
            type: String,
            default: '',
        },

    },
    beforeCreate() {
        // 给根组件也分配一个ID
        this.formRootId = uuid();
        injectAllStyleVar();
    },
    created() {
        // 组件映射关系
        this.constComponentMap = COMPONENT_MAP;
        this.globalModel.setViewType(Number(getUrlParam('viewType')) || 0);
    },
    destroyed() {
        this.removeCustomStyle();
    },
    data() {
        return {
            globalModel: new GlobalModel(),
            // 是否已完成全局model注册的标识
            globalModelInitiated: false,
            // props.formAttributes
            mixedFormAttributes: {},
            // 如果正在校验则不响应提交事件
            isValidating: false,
            // 是否锚定到第一个错误组件
            isAnchored: false,
            // 是否展示公告弹窗
            panelShow: false,
            // 弹窗打开时间
            noticeDialogOpenTime: 0,
        };
    },
    computed: {
        // 是否置灰button
        isButtonGray() {
            const formData = this.globalModel.formData;
            const dataKeys = Object.keys(formData);
            if (!this.config) {return false;}
            const props = this.config.props.children;
            for (const key of props) {
                if (dataKeys.includes(key.output) && key.props.required && !key.props.disabled && !key.props.hide) {
                    const data = formData[key.output];
                    // !data代表无数据，但是当mobile-general-form-user-select的data === RESULT_FALLBACK_VALUE(null)时，表示选择了兜底项
                    if (!data && !(key.component === 'mobile-general-form-user-select' && data === RESULT_FALLBACK_VALUE)) {
                        return true;
                    }
                    if (Array.isArray(data) && !data.length) {
                        return true;
                    }
                    if (key.component === 'mobile-general-form-id-upload' && (!data[0] || !data[1])) {
                        return true;
                    }
                }
            }
            return false;
        },
        mixedConfig() {
            return {
                ...this.config,
            };
        },
        mixedFormData() {
            return {
                ...this.formData,
            };
        },
        noticeLink() {
            if (this.formNotice && this.formNotice.noticeLink) {
                const laneId = getUrlParam('laneId');
                return laneId ? `${this.formNotice.noticeLink}&laneId=${laneId}` : this.formNotice.noticeLink;
            }
            return '';
        },
        // 驳回场景：有remark且非预览
        rejectNoticeBar() {
            return this.remark && !this.preview;
        },
        // formNotice表单
        formNoticeBar() {
            return !this.rejectNoticeBar && !this.preview && this.formNotice && this.formNotice.noticeLink;
        },
        showNoticeBar() {
            // 用户信息场景：非驳回且非预览
            return this.rejectNoticeBar || this.formNoticeBar;
        },
        // notice-bar显示的文案
        noticeBarText() {
            // 优先显示驳回的固定文案
            if (this.rejectNoticeBar) {
                return '您提交的内容部分填写错误，审核人员已为您整理出错误内容，请耐心查看，并按照要求重新上传。';
            }
            // 表单型公告
            if (this.formNoticeBar) {
                return this.formNotice.noticeTitle;
            }
            return '';
        },
        // 弹窗标题
        popupTitle() {
            // 驳回场景使用固定标题
            if (this.rejectNoticeBar) {
                return '请按以下要求更改';
            }
            // 表单型公告
            if (this.formNoticeBar) {
                return this.formNotice.popupTitle;
            }
            // 兜底使用固定标题
            return '请按以下要求更改';
        },

    },
    provide() {
        return {
            formRoot: this, // 给内层组件提供一个使用最外层的入口
        };
    },
    watch: {
        errorData: {
            immediate: true,
            handler(val) {
                val && this.globalModel.setErrorData(val);
            },
        },
        fieldReview: {
            immediate: true,
            handler(val) {
                this.globalModel.setFieldReview(val);
            },
        },
        initParams: {
            immediate: true,
            handler(initParams) {
                if (initParams && Object.keys(initParams).length > 0) {
                    // 外部传入的initParams有效
                    this.globalModel.setGlobalParams(initParams);
                }
            },
        },
        globalFormData: {
            immediate: true,
            handler(globalFormData) {
                if (globalFormData && Object.keys(globalFormData).length > 0) {
                    // 外部传入的globalFormData有效
                    this.globalModel.setGlobalFormData(globalFormData);
                }
            },
        },
        isEdit: {
            immediate: true,
            handler(isEdit) {
                this.globalModel.setIsEdit(isEdit);
            },
        },
        preview: {
            immediate: true,
            handler(newConfig) {
                this.globalModel.setPreview(newConfig);
            },
        },
        noticeFormPreview: {
            immediate: true,
            handler(newConfig) {
                this.globalModel.setNoticeFormPreview(newConfig);
            },
        },
        hideSubmitStyle: {
            immediate: true,
            handler(newConfig) {
                this.globalModel.setHideSubmitStyle(newConfig);
            },
        },
        config: {
            immediate: true,
            handler(newConfig, oldConfig) {
                if (isEqual(newConfig, oldConfig)) {
                    // 两次配置相同则无需重置
                    return;
                }
                if (newConfig && Object.keys(newConfig).length > 0) {
                    // 外部传入的config有效
                    // 重置是否注册完成的标识
                    // console.log('globalModelInitiated false');
                    this.globalModelInitiated = false;
                }
            },
        },
        mixedConfig: {
            immediate: true,
            handler(newConfig, oldConfig) {
                if (isEqual(newConfig, oldConfig)) {
                    // 两次配置相同则无需重置
                    return;
                }
                if (newConfig && Object.keys(newConfig).length > 0) {
                    // 新的配置有效
                    this.resetGlobalModel();
                }
            },
        },
        formAttributes: {
            immediate: true,
            handler: 'updateMixedFormAttributes',
        },
        'mixedFormAttributes.customStyle': {
            immediate: true,
            handler: 'updateCustomStyle',
        },
        mixedFormData(newData, oldData) {
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CUSTOM', 'MIXED_FORM_DATA', {
                new_data: newData,
                old_data: oldData,
            });
            // 数据变化后需要重新赋值
            if (!isEqual(newData, oldData)) {
                this.globalModel.setFormDataValueByPath('', cloneDeep(newData));
            }
        },
        'globalModel.formData': {
            deep: true,
            handler(newFormData) {
                const { hasChangeAllField = '' } = this.fieldReview && this.initHasChangeAllField();
                this.$emit('form-data-change', newFormData, hasChangeAllField, {
                    mappedData: this.getMappedData(),
                });
            },
        },
        remark: {
            immediate: true,
            handler(newConfig, oldConfig) {
                // case1: 会话中信息收集卡片--预览时不自动展示弹窗
                if (this.preview) {return;}
                // case2: 会话中信息收集卡片--查看更多时不自动展示弹窗
                if (this.hideSubmitStyle) {return;}
                if (newConfig) {
                    /*
                    FIXME：这里主要是因为picker-panel中watch value的逻辑，在此场景下默认value为true。丢失了value为true的逻辑。
                        又不能直接修改picker-panel中watch value为immediate，因为form中组件都是v-show的，会额外处理。。。。。暂且先用这种方式来实现。。后续有更好的方案再处理
                    */
                    setTimeout(() => {
                        if (this.noticeAutoOpen) {this.panelShow = true;}
                        formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'MODIFY_COLLECT_EXPLAIN_POPUP', {});
                    }, 100);
                }
            },
        },
        panelShow: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.noticeDialogOpenTime = +new Date();
                }
            },
        },
    },
    methods: {
        initHasChangeAllField() {
            const formChild = this.$refs.formRef && this.$refs.formRef.$refs.children;
            const childRejectTipStatus = [];
            let hasChangeAllField = '';
            if (formChild) {
                Array.from(formChild).forEach(element => {
                    const hasRejectTip = element.hasRejectTip; // 是否存在展示的驳回字段
                    const showRejectTip = element.showRejectTip; // 是否展示驳回的字段
                    const curOutPutPath = element.outputPath; // output
                    if (!element.props.hide && hasRejectTip) {
                        childRejectTipStatus.push({
                            showRejectTip,
                            curOutPutPath,
                        }); // 不展示即认为值已经变更
                        hasChangeAllField = childRejectTipStatus.filter(v => v.showRejectTip === true);
                    }
                });
            }
            return {
                hasChangeAllField,
            };
        },
        onClickNotice() {
            this.panelShow = !this.panelShow;
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'MODIFY_COLLECT_EXPLAIN_TIP', {});
        },
        exposedNoticeBar() {
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'MODIFY_COLLECT_EXPLAIN_TIP', {});
        },
        onClickBtn() {
            this.panelShow = !this.panelShow;
            this.closeNoticeDialogTrack(2);
        },
        onClickCloseIcon() {
            this.closeNoticeDialogTrack(1);
        },
        closeNoticeDialogTrack($buttonName) {
            const closeTime = +new Date();
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'MODIFY_COLLECT_EXPLAIN_POPUP_BUTTON', {
                button_name: $buttonName,
                duration: (closeTime - this.noticeDialogOpenTime) / 1000,
            });
        },
        resetGlobalModel() {
            this.globalModel.setFormDataValueByPath('', cloneDeep(this.mixedFormData));
            // 注册完成
            this.$nextTick(() => {
                this.globalModelInitiated = true;
            });
        },
        updateMixedFormAttributes() {
            this.mixedFormAttributes = {
                ...this.formAttributes,
            };
        },
        updateCustomStyle(customStyle) {
            this.removeCustomStyle();
            if (customStyle) {
                const styleElement = document.createElement('style');
                styleElement.type = 'text/css';
                styleElement.id = `mobile-general-form-style-${this.formRootId}`;
                styleElement.appendChild(document.createTextNode(customStyle));
                const head = document.head || document.getElementsByTagName('head')[0];
                head.appendChild(styleElement);
            }
        },
        removeCustomStyle() {
            const styleElementId = `mobile-general-form-style-${this.formRootId}`;
            const styleElement = document.getElementById(styleElementId);
            if (styleElement) {
                styleElement.parentNode.removeChild(styleElement);
            }
        },
        enableForm() {
            this.$set(this.mixedFormAttributes, 'disabled', false);
            this.$refs.formRef && this.$refs.formRef.$el && this.$refs.formRef.$el.scrollIntoView();
        },
        disableForm() {
            this.$set(this.mixedFormAttributes, 'disabled', true);
        },
        async onSubmitClick(source) {
            // 如果正在校验则不响应这一次调用
            if (this.isValidating) {
                this.$emit('is-validating');
                return;
            }
            this.clearValidateAll();
            const emitFormData = this.getEmitFormData();
            this.$emit('submit-click', emitFormData, source);
            this.isValidating = true;
            const valid = await this.validateAll();
            this.isValidating = false;
            this.isAnchored = false;
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'FORM_SUBMIT_BTN', {
                emitFormData,
                valid,
            });

            if (valid) {
                this.$emit('submit-valid', emitFormData, {
                    mappedData: this.getMappedData(),
                }, source);
            } else {
                // 非法的提示由组件级别处理了
                this.$emit('submit-invalid', emitFormData, source);
            }
        },
        /**
         * 以下方法供可供外部调用
         */
        async validateAll() {
            if (!this.$refs.formRef) {
                return false;
            }
            const res = await this.$refs.formRef.validate();
            return res;
        },
        clearValidateAll() {
            if (!this.$refs.formRef) {
                return;
            }
            this.$refs.formRef.clearValidate();
        },
        getFormDataValueByPath(path = '') {
            return this.globalModel.getFormDataValueByPath(path);
        },
        setFormDataValueByPath(path, value = {}) {
            return this.globalModel.setFormDataValueByPath(path, cloneDeep(value));
        },
        getEmitFormData() {
            // 这个开关不声明关闭就默认打开，过滤掉所有下划线开头的数据
            if (this.mixedFormAttributes.ksFilterLodashKey !== false) {
                return filterLodashKey(this.globalModel.formData);
            }
            return this.globalModel.formData;
        },
        // 由于出现了验证码这样的需求，开放了一个接口输出映射字段后的数据
        getMappedData() {
            return exportMappedData({
                mapping: this.mixedFormAttributes.exportMapping,
                formData: this.globalModel.formData,
            });
        },
    },
};
</script>
<style lang="less" scoped>
// 注意，这里引入的css非scoped，但是我们覆盖了类名保证了移动端通用表单使用的iconfont一定是同一个
@import '../assets/iconfont/mobile-general-form.css';
@import './style.less';

.iframe-container {
    width: 100%;
    height: 70vh;
    position: relative;
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70vh;
    color: #666;
}
</style>
